import AnimationGroup from './AnimationGroup';

export default AnimationGroup;
